import BreadcrumbRenderer from '@atlassian/jira-breadcrumbs/src/breadcrumb-renderer/index.tsx';
import withProps from '@atlassian/jira-common-with-props';
import Chevron from './chevron';
import HowTo from './how-to';
import HowToReadText from './how-to-read-text';
import Header from './main';

export default withProps({
	BreadcrumbRenderer,
	HowTo,
	Chevron,
	HowToReadText,
	// @ts-expect-error - TS2345 - Argument of type 'ComponentType<Diff<Record<any, any> | (Record<any, any> & { children?: ReactNode; }), InjectIntlVoidProps>>' is not assignable to parameter of type 'AbstractComponent<{ BreadcrumbRenderer: AbstractComponent<Diff<any, { onMount: (analyticsEvent: UIAnalyticsEventInterface) => void; TenantContextSubscriber: SubscriberComponent<State, BoundActions<State, Actions>, unknown>; }>, any>; HowTo: ComponentType<...>; Chevron: ComponentType<...>; HowToReadText: ComponentTyp...'.
})(Header);
